import React from 'react';

const StatCard = ({ title, value, change, icon, color = 'pink' }) => {
  return (
    <div className="stat-card">
      <div>
        <p>{title}</p>
        <h2>{value}</h2>
        <span>{change}</span>
      </div>
      <div className={`stat-icon ${color}`}>{icon}</div>
    </div>
  );
};

export default StatCard;